<template>
    <div id="service"  :style="{width:clientW+'px'}" style="margin:0 auto" :class="screenParm">
        <div class="service-img" v-for="(item,key) in imagesurl" :key="key">
            <img :src="imgPath+item.url" alt="" @click="setimages(key)">
        </div>
        <div class="back" @click="black">
            <img :src="imgPath+'back.png'" alt="">
        </div>
    </div>
</template>
<script>
import { ImagePreview } from 'vant';

export default {
    data(){
        return{
            clientW:document.body.clientWidth,
            clientH:document.body.clientHeight,
            imgPath:imgPath,
            screenParm:'',
            imagesurl:[
                {
                    id:'1',
                    url:"zcfw/1.jpg"
                },
                {
                    id:'2',
                    url:"zcfw/2.jpg"
                },
                {
                    id:'3',
                    url:"zcfw/3.jpg"
                },
                {
                    id:'4',
                    url:"zcfw/4.jpg"
                },
                {
                    id:'5',
                    url:"zcfw/5.jpg"
                },
                {
                    id:'6',
                    url:"zcfw/6.jpg"
                },
                {
                    id:'7',
                    url:"zcfw/7.jpg"
                },
                {
                    id:'8',
                    url:"zcfw/8.jpg"
                },
                {
                    id:'9',
                    url:"zcfw/9.jpg"
                },
                {
                    id:'10',
                    url:"zcfw/10.jpg"
                },
                {
                    id:'11',
                    url:"zcfw/11.jpg"
                },
                {
                    id:'12',
                    url:"zcfw/12.jpg"
                },
                {
                    id:'13',
                    url:"zcfw/13.jpg"
                },
                {
                    id:'14',
                    url:"zcfw/14.jpg"
                },
                {
                    id:'15',
                    url:"zcfw/15.jpg"
                },
                {
                    id:'16',
                    url:"zcfw/16.jpg"
                },
                {
                    id:'17',
                    url:"zcfw/17.jpg"
                },
                {
                    id:'18',
                    url:"zcfw/18.jpg"
                }
                
            ]
        }
    },
    created(){
        this.getViewScale();
    },
    methods: {
         getViewScale(){
            if(this.clientW >= 750){
                this.clientW = 414;
                this.clientH = 730;
            }
            if(this.clientH/this.clientW > 1.5 && this.clientH/this.clientW < 1.6){
                this.screenParm = "smallScreen";
            }else if(this.clientH/this.clientW <= 1.5){
                this.screenParm = "superSmallScreen";
            }else if(this.clientH/this.clientW >= 1.8){
                this.screenParm = "bigScreen";
            }else{
                this.screenParm = "middleScreen";
            }
        },
        black(){
            this.$router.back(-1);//放回上一页
        },
        setimages(val){
            var _this = this;
            ImagePreview({
            images: [
                this.imgPath+'zcfw/1.jpg',
                this.imgPath+'zcfw/2.jpg',
                this.imgPath+'zcfw/3.jpg',
                this.imgPath+'zcfw/4.jpg',
                this.imgPath+'zcfw/5.jpg',
                this.imgPath+'zcfw/6.jpg',
                this.imgPath+'zcfw/7.jpg',
                this.imgPath+'zcfw/8.jpg',
                this.imgPath+'zcfw/9.jpg',
                this.imgPath+'zcfw/10.jpg',
                this.imgPath+'zcfw/11.jpg',
                this.imgPath+'zcfw/12.jpg',
                this.imgPath+'zcfw/13.jpg',
                this.imgPath+'zcfw/14.jpg',
                this.imgPath+'zcfw/15.jpg',
                this.imgPath+'zcfw/16.jpg',
                this.imgPath+'zcfw/17.jpg',
                this.imgPath+'zcfw/18.jpg'
            ],
            startPosition: val,
            onClose() {
                // do something
            },
            });
        }
    },
}
</script>
<style lang="less" scoped>
 @base:46.875rem;
#service{
    background-color: #2c3266;
    .service-img{
        width: 100%;
    }
    .back{
        width: 113/@base;
        margin: 20/@base auto;
        padding-bottom: 20/@base;
    }
}  
</style>


// WEBPACK FOOTER //
// src/pages/Service.vue